import { ShieldCheck } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ConfettiPiece {
  id: number
  left: number
  delay: number
  duration: number
  color: string
  size: number
}

function Confetti() {
  const [pieces] = useState<ConfettiPiece[]>(() =>
    Array.from({ length: 10 }, (_, i) => ({
      id: i,
      left: 10 + Math.random() * 80,
      delay: Math.random() * 0.6,
      duration: 2 + Math.random() * 1.5,
      color: i % 2 === 0 ? 'var(--green)' : 'var(--gold)',
      size: 5 + Math.random() * 4,
    })),
  )

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden">
      {pieces.map((p) => (
        <div
          key={p.id}
          className="absolute top-[-10px] rounded-[1px]"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            backgroundColor: p.color,
            animation: `confetti-fall ${p.duration}s ease-in ${p.delay}s forwards`,
          }}
        />
      ))}
    </div>
  )
}

interface SuccessScreenProps {
  outroHtml?: string
  isForm?: boolean
}

export function SuccessScreen({ outroHtml, isForm = false }: SuccessScreenProps) {
  const { t } = useTranslation()
  const [showConfetti, setShowConfetti] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 4000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="panel-arrive flex flex-col items-center pt-12 text-center">
      {showConfetti && <Confetti />}

      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[var(--green-bg)]">
        <ShieldCheck
          size={36}
          className="animate-in zoom-in-75 text-[var(--green)] duration-500"
        />
      </div>

      <h1
        className="mb-3 font-display text-[28px] font-light leading-tight text-[var(--ink)]"
      >
        {isForm
          ? t('upload.form.successTitle', 'Your form has been submitted')
          : t('upload.successTitle')}
      </h1>

      <p className="clara-body mb-6 max-w-xs text-[var(--ink-2)]">
        {isForm
          ? t(
              'upload.form.successDescription',
              'Thank you. Your answers have been sent.',
            )
          : t('upload.successDescription')}
      </p>

      <div className="mx-auto mb-6 h-px w-16 bg-[var(--gold-border)]" />

      {outroHtml && (
        <div
          className="clara-body max-w-xs text-[var(--ink-2)]"
          dangerouslySetInnerHTML={{ __html: outroHtml }}
        />
      )}
    </div>
  )
}
